import { useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Select } from "antd";
import { toast } from "sonner";
import { getAllClass } from "../../api/pedagogicElement";
import { generateListeClasse } from "../../api/notes";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { Action, buildPermissionContext, Resource } from "../../core/common/autorisations/permissionsMap";

const ListeClasse = () => {
  const { selectedYear } = useAcademicYear();
  const [classes, setClasses] = useState<any[]>([]);
  const [classId, setClassId] = useState<string>();
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string>();

  useEffect(() => {
    let active = true;
    setClasses([]);
    setClassId(undefined);
    setPdfUrl(undefined);
    if (!selectedYear?.id) return;
    setLoadingClasses(true);
    getAllClass(selectedYear.id, buildPermissionContext(Resource.EMARGEMENT, Action.CREATE))
      .then((response) => {
        if (!active) return;
        const list = response.data || [];
        setClasses(list);
        setClassId(list[0]?.id?.toString());
      })
      .catch(() => { if (active) toast.error("Impossible de charger les classes"); })
      .finally(() => { if (active) setLoadingClasses(false); });
    return () => { active = false; };
  }, [selectedYear?.id]);

  useEffect(() => () => { if (pdfUrl) URL.revokeObjectURL(pdfUrl); }, [pdfUrl]);

  // Unmounting on a class/year change also prevents an old request replacing its preview.
  return (
    <ListeClasseContent key={`${selectedYear?.id}-${classId}`} {...{
      classes, classId, setClassId, loadingClasses, generating, setGenerating,
      pdfUrl, setPdfUrl, yearId: selectedYear?.id,
    }} />
  );
};

const ListeClasseContent = ({ classes, classId, setClassId, loadingClasses,
  generating, setGenerating, pdfUrl, setPdfUrl, yearId }: any) => {
  useEffect(() => { setPdfUrl(undefined); }, [setPdfUrl]);
  useEffect(() => { setGenerating(false); }, [setGenerating]);
  useEffect(() => {
    request.current = true;
    return () => { request.current = false; };
  }, []);
  const request = useRef(true);
  const generate = async () => {
    if (!classId || !yearId) return;
    setGenerating(true);
    try {
      const response = await generateListeClasse({ id_class: classId, id_academicYear: yearId });
      if (!request.current) return;
      setPdfUrl(URL.createObjectURL(new Blob([response], { type: "application/pdf" })));
      toast.success("Liste de classe générée avec succès");
    } catch {
      if (request.current) toast.error("Impossible de générer la liste de classe");
    } finally {
      if (request.current) setGenerating(false);
    }
  };
  return <>
    <div className="chat chat-messages" style={{ border: "1px solid #B5B9C3" }} id="middle">
      <div className="chat-header" style={{ borderBottom: "1px solid #B5B9C3" }}>
        <div className="user-details">
          <div className="bg-primary-light rounded-circle p-2 me-3"><i className="ion ion-clipboard fs-4" /></div>
          <h4>LISTE DE CLASSE</h4>
        </div>
      </div>
      {pdfUrl ? <iframe src={pdfUrl} title="Liste de classe — Aperçu PDF"
        style={{ width: "100%", height: "calc(100vh - 80px)", border: "none", marginTop: 10 }} /> :
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "calc(100vh - 80px)" }}>
          <i className="bx bx-file-blank fs-1 text-muted" />
          <h4 className="text-muted mb-2">Aucun PDF à afficher</h4>
          <p className="text-muted">Générez un nouveau PDF pour l'afficher ici</p>
        </div>}
    </div>
    <div className="right-sidebar right_sidebar_profile right-side-contact show-right-sidebar" id="middle1">
      <div className="right-sidebar-wrap active"><div className="slimscroll"><Scrollbars>
        <div className="sidebar-body">
          <div className="mt-0 right_sidebar_logo">
            <div className="text-center right-sidebar-profile">
              <div className="bg-primary-light rounded-circle p-2 me-3">
                <i className="ti ti-clipboard-check fs-4" />
              </div>
              <h5 className="profile-name">Paramètres</h5>
              <div className="last-seen-profile">
                <span>Sélectionnez la classe</span>
              </div>
            </div>
            <div className=" chat-member-details mb-2">
              <label className="form-label">Classe</label>
              <Select
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "").toString().toLowerCase()
                    .includes(input.toString().toLowerCase())
                }
                size="large"
                style={{ width: "100%" }}
                placeholder="Sélectionner la classe"
                value={classId}
                loading={loadingClasses}
                onChange={setClassId}
                options={classes.slice().sort((a: any, b: any) => {
                  const levelCompare = (a.Level?.label || "").localeCompare(
                    b.Level?.label || "", "fr", { numeric: true },
                  );
                  return levelCompare || a.label.localeCompare(b.label, "fr", { numeric: true });
                }).map((classe: any) => ({
                  label: `${classe.Level?.label || ""} - ${classe.label}`,
                  value: classe.id.toString(),
                }))}
                className="mb-2"
              />
            </div>
          </div>
        </div>
        <div className="right-sidebar-head share-media"><div className="d-grid gap-2 mb-4">
          <button className={generating ? "btn btn-primary-light" : "btn btn-primary"} type="button" onClick={generate}
            disabled={!classId || !yearId || loadingClasses || generating}>
            {generating ? <>
              <span className="spinner-border spinner-border-sm align-middle me-1" role="status" aria-hidden="true" />
              Chargement...
            </> : "Générer"}
          </button>
        </div></div>
      </Scrollbars></div></div>
    </div>
  </>;
};

export default ListeClasse;
